/**
 * Education Types
 */

export interface Resource {
    id: string
    title: string
    description: string
    type_id: string
    category_id: string
    url: string
    image_url?: string
    author?: string
    duration?: string
    featured: boolean
    priority?: number | null
    created_at: string
    status?: string
    submitted_by?: string
    submitted_by_name?: string
    reviewed_by?: string
    reviewed_at?: string
}

export interface ResourceCategoryInfo {
    id: string
    label: string
    active: boolean
    sort_order: number
}

export interface ResourceTypeInfo {
    id: string
    label: string
    icon: string
    active: boolean
}

export type ResourceType = 'video' | 'article' | 'guide' | 'course' | 'podcast' | 'tool'

export type ResourceCategory =
    | 'crypto-basics'
    | 'defi'
    | 'nft'
    | 'trading'
    | 'ai'
    | 'development'
    | 'security'
    | 'general'

export const RESOURCE_TYPES: Record<ResourceType, { label: string; icon: string }> = {
    'video': { label: 'Video', icon: 'pi-video' },
    'article': { label: 'Article', icon: 'pi-file' },
    'guide': { label: 'Guide', icon: 'pi-book' },
    'course': { label: 'Course', icon: 'pi-graduation-cap' },
    'podcast': { label: 'Podcast', icon: 'pi-microphone' },
    'tool': { label: 'Tool', icon: 'pi-wrench' },
}

export const RESOURCE_CATEGORIES: Record<ResourceCategory, string> = {
    'crypto-basics': 'Crypto Basics',
    'ai': 'AI & ML',
    'defi': 'DeFi',
    'nft': 'NFTs',
    'trading': 'Trading',
    'development': 'Development',
    'security': 'Security',
    'general': 'General',
}

export const SAMPLE_RESOURCES: Resource[] = [
    {
        id: '1',
        title: 'Introduction to DeFi',
        description: 'Learn the fundamentals of decentralized finance and how it works.',
        type_id: 'video',
        category_id: 'defi',
        url: 'https://youtube.com/watch?v=example',
        author: 'CryptoMondays',
        duration: '15 min',
        featured: true,
        created_at: new Date().toISOString(),
    },
    {
        id: '2',
        title: 'Smart Contract Security Guide',
        description: 'Best practices for writing secure smart contracts.',
        type_id: 'guide',
        category_id: 'security',
        url: 'https://docs.example.com/security',
        author: 'Security Team',
        featured: false,
        created_at: new Date().toISOString(),
    },
    {
        id: '3',
        title: 'AI in Web3: The Future',
        description: 'How AI is transforming the blockchain ecosystem.',
        type_id: 'article',
        category_id: 'ai',
        url: 'https://blog.example.com/ai-web3',
        author: 'Featured Guest',
        featured: true,
        created_at: new Date().toISOString(),
    },
]
